import React from "react";
import "../selector/selectorGenerico.css";

export default function SelectGenerico({
  label,          // Texto descriptivo del campo mostrado sobre el select
  id,             // Identificador único para asociar el label con el select
  value,          // Valor actualmente seleccionado (controlado por el padre)
  onChange,       // Función que se ejecuta cuando el usuario cambia la selección
  options = [],   // Array de objetos que se recorrerá para generar las opciones
  getOptionValue, // Función que indica qué propiedad será el value del option
  getOptionLabel, // Función que define el texto visible de cada opción
  placeholder = "Seleccionar..." // Texto de la opción inicial cuando no hay selección
}) {
  return (
    <div className="contenedor-select">
      {label && (
        <label htmlFor={id} className="select-label">
          {label}
        </label>
      )}

      <select
        id={id}
        className="select-input"
        value={value ?? ""}
        onChange={(e) => onChange(getOptionValue ? Number(e.target.value) : e.target.value)}
      >
        <option value="">{placeholder}</option>

        {options.map((item) => (
          <option
            key={getOptionValue(item)}
            value={getOptionValue(item)}
          >
            {getOptionLabel(item)}
          </option>
        ))}
      </select>
    </div>
  );
}